import axios from 'axios';
import { tiendaApiBase } from '@/utils/tiendaApiBaseUrl';

/**
 * Misma convención que kosexa-operaciones (`VUE_APP_API_URL` → …/tienda/).
 * Muchos entornos solo definen `VUE_APP_API_URL`; si falta `VUE_APP_API_URL_TIENDA`, el uso
 * ecommerce no se registraba y el resumen en Operaciones quedaba en cero.
 */

/**
 * Registra una vista de la SPA tienda (cabecera `shp` la pone axios en main.js).
 */
export async function postTiendaFrontUsoHit({ route_name: routeName, path, session_id: sessionId }) {
  const base = tiendaApiBase();
  if (!base) {
    return { status: 'skipped', reason: 'no_api_url' };
  }
  const url = `${base}public/uso-front/hit/`;
  // No lanzar en 404: en producción a veces el API aún no incluye esta ruta (`tienda/urls_public.py`).
  const res = await axios.post(
    url,
    {
      route_name: routeName,
      path: path || '',
      session_id: sessionId,
    },
    { validateStatus: () => true }
  );
  if (res.status === 404) {
    return { status: 'skipped', reason: 'endpoint_not_found' };
  }
  if (res.status < 200 || res.status >= 300) {
    return { status: 'skipped', reason: 'http_error', http_status: res.status };
  }
  return res.data;
}
